import { toDataURL } from "qrcode"
import { useCallback, useEffect } from "react"
import { useContext } from "react"
import { useState } from "react"
import { MdContentCopy } from "react-icons/md"
import { useParams } from "react-router-dom"
import UserContext from "../../Context/UserContext"
import { getEventsDocWhereExhibitor } from "../../Requests/firebaseFirestore"

export default function InvitePage () {

  const [events, setEvents] = useState([])
  const [event, setEvent] = useState('')
  const [qrCode, setQrCode] = useState('')
  const {role} = useParams()
  const {user, seeAs, url} = useContext(UserContext)


  const setEventsList = useCallback(
    async () => {
      let exhEvents
      if(seeAs===''){
        exhEvents = user.events.map(event=> event.name)
      }else{
        exhEvents = seeAs.events.map(event=> event.name)
      }
      const res = await getEventsDocWhereExhibitor(exhEvents)
      setEvents([...res])
    },[seeAs, user]) 

  const handleEventInput = async (e) =>{
    const {value} = e.target 
    setEvent(value)
    const qr = await toDataURL(`${url}/invitationform/${value}`)
    setQrCode(qr)
  }

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text)
  }

  const setQr = useCallback(async()=>{
    const qr = await toDataURL(`${url}/invitationform/${user.event.id}`)
    setQrCode(qr)
  },[])

  useEffect(()=>{
    if(role==='exhibitor'){
      setEventsList()
    }else{
      setQr()
    }
  },[])

  return <div className="container mx-auto px-4">
    <h1 className="text-stone-600 font-semibold text-xl py-2 text-center mt-5">Invitar a evento</h1>
    {role==='exhibitor'?
    <div className="border border-stone-400 mt-2 mx-auto max-w-[500px] w-1/2 min-w-[300px] rounded-[10px] py-4 px-6 flex flex-col justify-center gap-4">
      <div className="input-holder w-[75%]">
        <select name="event" id="invite-event" value={event} onChange={handleEventInput}>
          <option value="" hidden disabled></option>
          {events.map((event,index) => {return(
            <option key={index} value={event.id}>{event.name}</option>
            )})}
        </select>
        <label htmlFor="invite-event">Elegir un evento</label>
      </div>
      {event!==''?<div className="flex w-[75%] mx-auto">
          <div className="flex flex-col justify-center gap-4 w-1/2">
            {window.isSecureContext?
            <button onClick={()=>{handleCopy(`${url}/invitationform/${event}`)}} className='flex mx-auto hover:underline' id='copy-invitation'><MdContentCopy size={25}/>copiar link</button>
            :
            <span className="break-words">{`${url}/invitationform/${event}`}</span>}
            <a href={qrCode} download={`invitation-${event.name}`} className="send-btn text-center">descargar QR</a>
          </div>
          <div className="w-1/2">
          <img src={qrCode} alt="qr code" className="mx-auto"/>
          </div>
      </div>:<></>}
      </div>
      :<>
      <div className="border border-stone-400 mt-2 mx-auto max-w-[500px] w-1/2 min-w-[300px] rounded-[10px] py-4 px-6 flex flex-col justify-center">
          <h1 className="text-center font-semibold text-lg">{user.event.name}</h1>
        <div className="flex w-fit gap-4 mx-auto">
          <div className="flex flex-col justify-center gap-4 w-1/2">
            {window.isSecureContext?
            <button onClick={()=>{handleCopy(`${url}/invitationform/${event}`)}} className='flex mx-auto hover:underline w-fit' id='copy-invitation'><MdContentCopy size={25}/>copiar link</button>
            :
            <span className="break-words">{`${url}/invitationform/${event}`}</span>}
            <a href={qrCode} download={`invitation-${user.event.name}`} className="send-btn text-center">descargar QR</a>
          </div>
          <div className="w-1/2">
          <img src={qrCode} alt="qr code" className="mx-auto"/>
          </div>
        </div>
      </div>
      </>}
      </div>
}